

















































































export default {
  props:{
    establishment: Object
  },
  computed:{
    satisfaction: ()->
      ret = 0
      if parseInt(@establishment.nb_negative) + parseInt(@establishment.nb_positive) > 0
        ret =  Math.round(100 * parseInt(@establishment.nb_positive) /(parseInt(@establishment.nb_positive) + parseInt(@establishment.nb_negative)))                
      return ret
  }
}
